var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / List") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-List",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(3.000000, 4.000000)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 25.6666667,
    y1: 3.33333333,
    x2: 9.66666667,
    y2: 3.33333333,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.6666667,
    y1: 12,
    x2: 9.66666667,
    y2: 12,
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.333333333,
    y: 0.666666667,
    width: 5.33333333,
    height: 5.33333333,
    rx: 1.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.333333333,
    y: 9.33333333,
    width: 5.33333333,
    height: 5.33333333,
    rx: 1.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.333333333,
    y: 18,
    width: 5.33333333,
    height: 5.33333333,
    rx: 1.33333333
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.6666667,
    y1: 20.6666667,
    x2: 9.66666667,
    y2: 20.6666667,
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.e0526fc0089de263398893e0a370dc0e.svg";
export { ForwardRef as ReactComponent };